export default "__VITE_ASSET__DKl2ihQg__"